<template>
  <div>
    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('rent')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.rent"
              v-validate="{ ...requiredMoney(getMaintenanceExpensesQuestions.costs.rent.required) }"
              :label="getMaintenanceExpensesQuestions.costs.rent.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.rent'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.rent')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.rent')"
              :required="getMaintenanceExpensesQuestions.costs.rent.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('electricity')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.electricity"
              v-validate="{
                ...requiredMoney(getMaintenanceExpensesQuestions.costs.electricity.required)
              }"
              :label="getMaintenanceExpensesQuestions.costs.electricity.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.electricity'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.electricity')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.electricity')"
              :required="getMaintenanceExpensesQuestions.costs.electricity.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('gas')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.gas"
              v-validate="{ ...requiredMoney(getMaintenanceExpensesQuestions.costs.gas.required) }"
              :label="getMaintenanceExpensesQuestions.costs.gas.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.gas'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.gas')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.gas')"
              :required="getMaintenanceExpensesQuestions.costs.gas.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('water')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.water"
              v-validate="{
                ...requiredMoney(getMaintenanceExpensesQuestions.costs.water.required)
              }"
              :label="getMaintenanceExpensesQuestions.costs.water.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.water'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.water')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.water')"
              :required="getMaintenanceExpensesQuestions.costs.water.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('internet')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.internet"
              v-validate="{
                ...requiredMoney(getMaintenanceExpensesQuestions.costs.internet.required)
              }"
              :label="getMaintenanceExpensesQuestions.costs.internet.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.internet'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.internet')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.internet')"
              :required="getMaintenanceExpensesQuestions.costs.internet.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="getMaintenanceExpensesQuestions.costs.hasOwnProperty('phone')"
      :wrap="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        md12
        lg9
      >
        <v-layout wrap>
          <v-flex
            xs12
            md7
            lg7
          >
            <v-text-field
              v-model="costs.phone"
              v-validate="{
                ...requiredMoney(getMaintenanceExpensesQuestions.costs.phone.required)
              }"
              :label="getMaintenanceExpensesQuestions.costs.phone.label"
              :error-messages="
                errors.collect($t('sheet.sheetOne.meeting.maintenance_expenses.label.phone'))
              "
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.phone')"
              :data-vv-name="$t('sheet.sheetOne.meeting.maintenance_expenses.label.phone')"
              :required="getMaintenanceExpensesQuestions.costs.phone.required"
              :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
              :disabled="readOnly"
              inputmode="decimal"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div v-if="getMaintenanceExpensesQuestions.hasOwnProperty('heating')">
      <h4
        class="display-1 mb-2 mt-4 sz_grafit--text"
        :class="{ required: getMaintenanceExpensesQuestions.heating.required }"
      >
        {{ getMaintenanceExpensesQuestions.heating.label }}
      </h4>
      <v-layout wrap>
        <v-flex
          v-for="(item, index) in heatingType"
          :key="index"
          wrap
          xs12
        >
          <v-checkbox
            v-model="heating"
            v-validate="{ required: getMaintenanceExpensesQuestions.heating.required }"
            multiple
            class="column"
            :label="item.description"
            :value="item.id"
            :error="errors.has('heating')"
            :error-messages="index + 1 === heatingType.length ? errors.collect('heating') : null"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'heating'"
            :disabled="readOnly"
          />
          <furnaceForm
            v-if="
              (item.id === 355 || item.id === 56) &&
                furnaceFormVisibility &&
                getMaintenanceExpensesQuestions.hasOwnProperty('details')
            "
            class="mt-4"
            :read-only="readOnly"
            @value="fuelCosts = $event"
          />
          <OtherHeatingForm
            v-if="
              item.id === 359 &&
                heating.includes(359) &&
                getMaintenanceExpensesQuestions.hasOwnProperty('other_heating')
            "
            class="mt-4"
            :read-only="readOnly"
            @value="otherHeatingCosts = $event"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import FurnaceForm from '@/components/widgets/sheet/questions/maintenanceExpenses/furnaceForm';
import validationRules from '@/constants/validationRules';
import formatDecimalVariables from '@/mixins/formatDecimalVariables';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import OtherHeatingForm from '@/components/widgets/sheet/questions/maintenanceExpenses/OtherHeatingForm';

import filters from '@/constants/filters';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getMaintenanceExpensesField',
    mutationType: 'sheet/updateMaintenanceExpensesField'
});

export default {
    name: 'MonthlyExpensesForm',
    components: { FurnaceForm, OtherHeatingForm },
    filters: { ...filters },
    mixins: [formatDecimalVariables, sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            otherHeatingCosts: 0,
            fuelCosts: 0
        };
    },
    watch: {
        regwip: {
            immediate: true,
            handler (val) {
                this.$emit('value', val);
            }
        },
        heating: {
            immediate: true,
            handler (val) {
                if (!this.furnaceFormVisibility) {
                    this.fuelCosts = 0;
                }
                if (!val.includes(359)) {
                    this.otherHeatingCosts = 0;
                }
            }
        }
    },
    computed: {
        ...mapFields(['costs', 'heating']),
        ...mapGetters('sheet', ['getMaintenanceExpensesQuestions']),
        furnaceCosts () {
            return this.otherHeatingCosts + this.fuelCosts;
        },
        regwip () {
            const value =
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.rent)) +
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.electricity)) +
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.gas)) +
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.water)) +
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.internet)) +
        this.$options.filters.emptyToZero(this.formatDecimalVariable(this.costs.phone));
            return parseFloat(parseFloat(value + this.furnaceCosts).toFixed(2));
        },
        heatingType () {
            return this.getResources(this.getMaintenanceExpensesQuestions.heating);
        },
        furnaceFormVisibility () {
            return this.heating.includes(56) || this.heating.includes(355);
        }
    },
    methods: {
        hasSlot (id) {
            const availableID = [56, 355, 359];
            return availableID.includes(id);
        }
    }
};
</script>

<style scoped></style>
